import overrideTableStyles from './Table'
import overrideCardStyles from "Theme/overrides/Card"
import overridePaperStyles from "Theme/overrides/Paper"
import overrideInputStyles from "Theme/overrides/Inputs"
import overrideProgressStyles from "Theme/overrides/Progress"


const overrideComponents = theme => Object.assign(
	overrideTableStyles(theme),
	overrideCardStyles(theme),
	overridePaperStyles(theme),
	overrideInputStyles(theme),
	overrideProgressStyles(theme),
)

export default overrideComponents